// extracted by mini-css-extract-plugin
module.exports = {"hiddenInput":"Input_hiddenInput__450WS","input":"Input_input__4KUn_"};